import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { Select } from '@ipfabric/ui-components/Select/Select';
import { isObjectTableFilter } from '@ipfabric/utils';
import type { FC, ReactNode } from 'react';
import { SimpleFilterInput } from './SimpleFilterInput';
import { getChildFilterField } from './helpers/getChildFilterField';
import type { ChangeFilterEvent } from './types/ChangeFilterEvent';
import type { SimpleFilterField } from './types/SimpleFilterField';

interface Props {
  filterField: SimpleFilterField;
  onChangeFilter: (command: ChangeFilterEvent) => void;
  onSubmitFilters: () => void;
  intentFilter?: ReactNode;
  filterHiddenButton?: ReactNode;
  autoFocus?: boolean;
}

export const SimpleObjectFilter: FC<Props> = (props) => {
  const { filter } = props.filterField;

  if (!isObjectTableFilter(filter)) {
    stumble('Passing non object table filter to SimpleObjectFilter');

    return null;
  }

  const handleChange = async (value: string | null) => {
    await props.onChangeFilter({
      column: props.filterField.column,
      value: null,
      child: value,
    });

    if (value === null) {
      props.onSubmitFilters();
    }
  };

  const options = filter.children.map(({ field, title }) => ({
    label: title,
    value: field,
  }));

  const handleChangeFilter = (command: ChangeFilterEvent) => {
    props.onChangeFilter({
      ...command,
      column: props.filterField.column,
      child: props.filterField.child,
    });
  };

  const childFilterField = getChildFilterField(props.filterField);

  return (
    <>
      <div className='flex'>
        {props.intentFilter}
        {props.filterHiddenButton ? (
          props.filterHiddenButton
        ) : (
          <Select.Optional
            className='flex-1'
            clearable
            options={options}
            value={props.filterField.child ?? null}
            onChange={handleChange}
            size='small'
            autoFocus={props.autoFocus}
          />
        )}
      </div>
      {childFilterField && !props.filterHiddenButton && (
        <SimpleFilterInput
          onChangeFilter={handleChangeFilter}
          onSubmitFilters={props.onSubmitFilters}
          filterField={childFilterField}
          autoFocus
        />
      )}
    </>
  );
};
